module.exports = __webpack_public_path__ + "static/media/nodejs.acd118be.svg";